import { useContext } from "react";
import "react-international-phone/style.css";
import { PhoneInput } from "react-international-phone";
import RequestQuoteFormContext from "./RequestQuoteFormContext";
import { useState } from "react";

const Contact = () => {
	const { contact, setContact, next, prev } = useContext(
		RequestQuoteFormContext
	);

	const handleChange = (first, second) => {
		if (second && second.name) {
			setContact((prev) => ({
				...prev,
				[second.name]: first,
			}));
		} else if (second?.inputValue) {
			setContact((prev) => ({
				...prev,
				phone_number: second.inputValue,
			}));
		} else if (first?.target) {
			const { name, value } = first.target;
			setContact((prev) => ({ ...prev, [name]: value }));
		}
	};

	const [errors, setErrors] = useState({});

	const handleSubmit = (e) => {
		e.preventDefault();
		const newErrors = {};

		if (!contact.full_name || contact.full_name.trim() === "") {
			newErrors.full_name = "Full name is required.";
		}
		if (
			!contact.phone_number ||
			contact.phone_number.trim() === "" ||
			!/^\+?\d{7,15}$/.test(contact.phone_number.replace(/\s+/g, ''))
		) {
			newErrors.phone_number = "Valid phone number is required.";
		}
		if (
			!contact.email_address ||
			contact.email_address.trim() === "" ||
			!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email_address)
		) {
			newErrors.email_address = "Valid email address is required.";
		}

		setErrors(newErrors);

		if (Object.keys(newErrors).length > 0) {
			console.log("Validation errors:", newErrors);
			return;
		}

		next();
	};

	return (
		<form className="quote-form">
			<div className="contact-input d-flex flex-column ">
				<span>Fullname</span>
				<input
					type="text"
					name="full_name"
					value={contact.full_name}
					onChange={handleChange}
					required
				/>
				<span className="text-danger">{errors && errors.full_name}</span>
			</div>

			<div className="contact-input d-flex flex-column ">
				<span>Phone Number</span>
				<PhoneInput
					defaultCountry="ae"
					name="phone_number"
					value={contact.phone_number}
					onChange={handleChange}
					required
				/>
				<span className="text-danger">{errors && errors.phone_number}</span>
			</div>

			<div className="contact-input d-flex flex-column ">
				<span>Email Address</span>
				<input
					type="email"
					name="email_address"
					value={contact.email_address}
					onChange={handleChange}
					required
				/>
				<span className="text-danger">{errors && errors.email_address}</span>
			</div>
			<div className="row g-3">
				<div className="col-6 col-md-6 col-lg-6">
					<button onClick={prev} className="btn mt-3 w-100">
						Back
					</button>
				</div>
				<div className="col-6 col-md-6 col-lg-6">
					<button onClick={handleSubmit} className="btn mt-3 w-100">
						Next
					</button>
				</div>
			</div>
		</form>
	);
};
export default Contact;
